import { useEffect } from 'react';

import { isApplicationPmi } from '@lib/core/service/consts';
import { isAppInIframe } from '@lib/core/service/utils';
import { initComms } from '@lib/tools/comms/utils';
import { useTypedDispatch } from '@lib/tools/views/hooks';

const CommsProvider = ({ children }) => {
  const dispatch = useTypedDispatch();

  /**
   * * Setup postMessage listener
   */
  useEffect(() => {
    // Listen for messages from hosting libraries
    if (isAppInIframe || isApplicationPmi) {
      initComms(dispatch);
    }
  }, []);

  // ! Support VH handshake.
  return children;
};

export default CommsProvider;
